import EmailTemplateFilters from './EmailTemplateFilters';

export default EmailTemplateFilters;
